import React from "react";
import "./StockControllAdministrativo.scss";
function StockControllAdministrativo({ stock }) {
  return (
    <div className="caixa stockControllAdministrativo__container">
      <span className="dashboardAdministrativoFinanceiro__titulo">
        Stock: Controle de reposição
      </span>
      <div className="stockControllAdministrativo__content">
        {stock && stock.length > 0 && (
          <ul>
            {/* Os nomes dos campos não são os que aqui estavam: o endpoint
                devolve `produto.nome` e `quantidadeTotal` (ver a projeção do
                getProdutosStockAEsgotar). Com `produto.produto` e `quantidade`
                a lista saía com os itens em branco, nunca escrevia ESGOTADO e
                as cores de aviso nunca pegavam. */}
            {stock.map((s, index) => (
              <li
                key={s.produto?._id || index}
                className={`stockControllAdministrativo__li ${
                  s.quantidadeTotal === 0
                    ? "stockControllAdministrativo__li--danger"
                    : "stockControllAdministrativo__li--warning"
                }`}
              >
                {s.produto?.nome}
                {s.quantidadeTotal === 0
                  ? " - ESGOTADO"
                  : ` - ${s.quantidadeTotal}/${s.quantidadeIdeal}`}
              </li>
            ))}
          </ul>
        )}
        {(!stock || stock.length === 0) && <span>Sem dados por mostrar</span>}
      </div>
    </div>
  );
}

export default StockControllAdministrativo;
